<!-- Visualização normal (sem comparar versões) -->
<ng-container *ngIf="!comparingVersions">
    <div class="row">
        <div class="col-12" [class.col-lg-4]="activeTab === 'complementary'"
            [class.col-lg-12]="activeTab === 'address'"
            *ngIf="['complementary', 'address', 'all'].includes(activeTab)">
            <ng-container *ngIf="cardLoading?.basic_data">
                <ngx-skeleton-loader [theme]="{
                        height: '468px',
                        margin:'0  0 24px'
                    }" *ngIf="['complementary', 'all'].includes(activeTab)">
                </ngx-skeleton-loader>
            </ng-container>

            <div class="dash-details-card"
                *ngIf="!cardLoading.basic_data && ['complementary', 'all'].includes(activeTab)">
                <div class="dash-details-card-header">
                    <span>Dados básicos</span>

                    <ng-container *ngIf="filteredFiles?.basic_info">
                        <app-attachment-button
                            [slugArr]="filteredFiles.basic_info"
                            (onSelect)="handleSelect($event,'basic_info')">
                        </app-attachment-button>
                    </ng-container>
                </div>
                <app-spacer [bottom]="15"></app-spacer>


                <!-- Empty state quando não há dados básicos -->
                <ng-container *ngIf="!hasBasicData()">
                    <div class="dash-details-card-body"
                        style="padding: 60px 20px; min-height: 200px;">
                        <app-empty-content [isVisible]="true"
                            title="Nenhum dado básico disponível"
                            description="Não há informações de dados básicos cadastradas para este registro."
                            icon="/assets/images/forgot-password-icon2.png">
                        </app-empty-content>
                    </div>
                </ng-container>

                <!-- PF UNIFICADO -->
                <ng-container
                    *ngIf="approval.register.type === 'PF' && !isSimplified">
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        CPF
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person.document?.number
                                        ?
                                        formatCpf(approval.register.person.document.number)
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        DATA DE NASCIMENTO
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person.birth_date ?
                                        (approval.register.person.birth_date |
                                        date: 'dd/MM/yyyy') :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        País de origem
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getNationalityDisplay(approval.register.person.nationality)}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>

                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Naturalidade (UF)
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getStateDisplayName(approval.register.person.naturalness)}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Naturalidade (Cidade)
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person.naturalness_city?.name
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Gênero
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{
                                        getChoicesName('gender_choices',approval.register.person.gender)?.label
                                        ?? '--'
                                        }}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>


                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Estado civil
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{
                                        getChoicesName('marital_choices',approval.register.person.marital_status)?.label
                                        ?? '--'
                                        }}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        CPF DO CÔNJUGE
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person?.spouse?.document
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>


                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        NOME DO CÔNJUGE
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person?.spouse?.name
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        REGIME DE CASAMENTO
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person?.spouse &&
                                        approval.register.person.spouse.marriage_bond
                                        ?
                                        getChoicesName('marital_statutes',approval.register.person.spouse.marriage_bond)?.label
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>


                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        NOME DA MÃE
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person.mother_name
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>


                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        NOME DO PAI
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person.father_name
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Tipo de documento
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person.secondary_document?.type?.name
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Número do documento
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person.secondary_document
                                        &&
                                        approval.register.person.secondary_document.number
                                        ?
                                        handleFormatDocument(approval.register.person.secondary_document):
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Órgão expedidor
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <ng-container
                                            *ngIf="approval.register.person.secondary_document && approval.register.person.secondary_document.uf">
                                            {{approval.register.person.secondary_document.uf}}/
                                        </ng-container>

                                        {{approval.register.person.secondary_document
                                        &&
                                        approval.register.person.secondary_document.dispatching_agency
                                        ?
                                        approval.register.person.secondary_document.dispatching_agency
                                        :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Data de expedição
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <ng-container
                                            *ngIf="approval.register.person.secondary_document && approval.register.person.secondary_document.expedition_date">
                                            {{approval.register.person.secondary_document.expedition_date
                                            |
                                            date: 'dd/MM/yyyy'}}
                                        </ng-container>

                                        <ng-container
                                            *ngIf="!approval.register.person.secondary_document || !approval.register.person.secondary_document.expedition_date">
                                            --
                                        </ng-container>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12"
                                *ngIf="!checkIsFund(approval.register)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Email
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <a [href]="'mailto:'+approval.register.person?.email"
                                            target="_blank">
                                            {{approval.register.person.email
                                            ?? '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <ng-container
                                *ngIf="hasAnyRole(['assignor', 'provider'])">
                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Site
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            <a [href]="approval.register.person.site"
                                                target="_blank">
                                                {{approval.register.person.site
                                                &&
                                                approval.register.person.site
                                                !== '
                                                ' ?
                                                approval.register.person.site :
                                                '--'}}
                                            </a>
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Faturamento
                                            nos últimos 12 meses
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{formatBrl(approval.register.person.revenues)
                                            ??
                                            '--'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="hasAnyRole(['assignor'])">
                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Faz parte do SFN
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.person.sfn
                                            ? 'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>

                <ng-container
                    *ngIf="approval.register.type === 'PF' && isSimplified ">
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        CPF
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person.document?.number
                                        ?
                                        formatCpf(approval.register.person.document.number)
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        DATA DE NASCIMENTO
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person.birth_date ?
                                        (approval.register.person.birth_date |
                                        date: 'dd/MM/yyyy') :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        País de origem
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getNationalityDisplay(approval.register.person.nationality)}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        DOCUMENTO
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person.document?.number
                                        ?
                                        formatCpf(approval.register.person.document.number)
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        DATA DE EXPEDIÇÃO
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.person.document.expedition_date
                                        | date:'dd/MM/yyyy' ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Gênero
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{
                                        getChoicesName('gender_choices',approval.register.person.gender)?.label
                                        ?? '--'
                                        }}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <!-- /PF UNIFICADO -->

                <!-- PJ UNIFICADO -->

                <ng-container
                    *ngIf="approval.register.type === 'PJ' && isSimplified">
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12 col-lg-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        CNPJ
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.document.number
                                        ?
                                        formatCnpj(approval.register.company.document.number)
                                        :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Nome Fantasia
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.brand_name
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Data de fundação
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.foundation_date
                                        |
                                        date:
                                        'dd/MM/yyyy' ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        CNAE
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.cnae?.name
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        capital social
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.capital ?
                                        formatBrl(approval.register.company.capital)
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        faturamento bruto anual
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{formatBrl(approval.register.company.yearly_income)
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        N.º de funcionários
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.number_employees
                                        ?
                                        getEmployeesName(approval.register.company.number_employees)
                                        :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container
                    *ngIf="approval.register.type === 'PJ' && !isSimplified">
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        CNPJ
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.document?.number
                                        ?
                                        formatCnpj(approval.register.company.document.number)
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Nome Fantasia
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.brand_name
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Data de fundação
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.foundation_date
                                        |
                                        date:
                                        'dd/MM/yyyy' ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Forma de constituição
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.branch_display
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Natureza jurídica
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.framework?.name
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <ng-container
                                *ngIf="!checkIsFund(approval.register)">
                                <div class="col-12 col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Inscrição municipal
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.municipal_registration
                                            ??
                                            '--'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12 col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Inscrição estadual
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.state_registration
                                            ??
                                            '--'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12 col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Isento de inscrição estadual
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.free_state_registration
                                            ? 'Sim': 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12 col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            NIRE
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.nire ??
                                            '--'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="col-12 col-md-6"
                                *ngIf="hasAnyRole(['assignor', 'shareholder']) && checkIsFund(approval.register)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        GIIN
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.giin ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6"
                                *ngIf="hasAnyRole(['assignor', 'shareholder']) && checkIsFund(approval.register)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Tipo de contrato
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.contract_type
                                        ?
                                        renderContractType(approval.register.company.contract_type):
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <ng-container
                                *ngIf="checkIsFund(approval.register)">
                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Trata-se de um fundo exclusivo?
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.exclusive_fund
                                            ? 'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Celular
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <a [href]="'tel:'+approval.register.company.cellphone?.number"
                                            target="_blank">
                                            {{formatPhone(approval.register.company.cellphone?.number)
                                            ?? '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Telefone
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <a [href]="'tel:'+approval.register.company.phone?.number"
                                            target="_blank">
                                            {{formatPhone(approval.register.company.phone?.number)
                                            ?? '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12"
                                *ngIf="!checkIsFund(approval.register)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Email
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <a [href]="'mailto:'+approval.register.company?.contact_email"
                                            target="_blank">
                                            {{approval.register.company?.contact_email
                                            ?? '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12"
                                *ngIf="!checkIsFund(approval.register)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Site
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <a [href]="approval.register.company.site"
                                            target="_blank">
                                            {{approval.register.company.site &&
                                            approval.register.company.site !== '
                                            ' ?
                                            approval.register.company.site :
                                            '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        CNAE
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.cnae ?
                                        approval.register.company.cnae.name :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6"
                                *ngIf="!checkIsFund(approval.register)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        PORTE
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.company_size_display
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12 col-md-6"
                                *ngIf="!checkIsFund(approval.register)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        N.º de funcionários
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{approval.register.company.number_employees
                                        ?
                                        getEmployeesName(approval.register.company.number_employees)
                                        :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <ng-container
                                *ngIf="hasAnyRole(['assignor']) || hasShareholderRole()">
                                <div class="col-12 col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            faturamento bruto anual
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.yearly_income
                                            ?
                                            formatBrl(approval.register.company.yearly_income)
                                            : '--'}}
                                        </span>
                                    </div>
                                </div>

                                <div class="col-12 col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            capital social
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.capital
                                            ?
                                            formatBrl(approval.register.company.capital)
                                            :
                                            '--'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <ng-container *ngIf="hasAnyRole(['assignor'])">
                        <div class="divider"></div>
                        <app-spacer [bottom]="30"></app-spacer>

                        <div class="dash-details-card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            coobrigação
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.assignor?.joint_obligation
                                            === "true"
                                            ? 'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Em recuperação judicial
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.judicial_recovery
                                            ? 'Sim' : 'Não'}}
                                            <ng-container
                                                *ngIf="approval.register.company.judicial_recovery_date">
                                                ,
                                                {{approval.register.company.judicial_recovery_date
                                                | date: 'dd/MM/yyyy'}}
                                            </ng-container>
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Emite boleto
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.billet_emitter
                                            ?
                                            'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>


                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Emite NFe
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.nfe_emitter
                                            ?
                                            'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>


                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Emite duplicata
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.duplicate_emitter
                                            ? 'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle">
                                            Faz parte do SFN
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{approval.register.company.sfn
                                            ? 'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <!-- /PJ UNIFICADO -->
            </div>

            <app-spacer [bottom]="24"></app-spacer>

            <ng-container *ngIf="cardLoading.basic_data">
                <ngx-skeleton-loader [theme]="{
                        height: '468px',
                        margin:'0'
                      }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container
                *ngIf="!isSimplified && !checkIsFund(approval.register) && !cardLoading.address && ['complementary', 'address', 'all'].includes(activeTab)">
                <div class="dash-details-card address-card">
                    <div class="dash-details-card-header">
                        <span>Endereço</span>

                        <ng-container *ngIf="filteredFiles.address">
                            <app-attachment-button
                                [slugArr]="filteredFiles.address"
                                (onSelect)="handleSelect($event,'address')">
                            </app-attachment-button>
                        </ng-container>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>

                    <!-- Empty state quando não há endereço -->
                    <ng-container *ngIf="!hasAddress()">
                        <div class="dash-details-card-body"
                            style="padding: 60px 20px; min-height: 200px;">
                            <app-empty-content [isVisible]="true"
                                title="Nenhum endereço cadastrado"
                                description="Não há informações de endereço cadastradas para este registro."
                                icon="/assets/images/forgot-password-icon2.png">
                            </app-empty-content>
                        </div>
                    </ng-container>

                    <!-- Conteúdo quando há endereço -->
                    <ng-container *ngIf="hasAddress()">
                        <div class="dash-details-card-body"
                            [ngClass]="comparingVersions && getFieldStatus('register.address', 'comparing') === 'removed' ? 'address-removed' : ''"
                            [style.border-bottom]="comparingVersions && getFieldStatus('register.address', 'comparing') === 'removed' ? '2px solid var(--danger)' : 'none'">
                            <div class="row">
                                <div class="col-12 d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        CEP
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [style.text-decoration]="comparingVersions && getFieldStatus('register.address', 'comparing') === 'removed' ? 'line-through' : 'none'">
                                        {{approval.register.address?.cep ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>

                                <div class="col-12 d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        ENDEREÇO COMPLETO
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [style.text-decoration]="comparingVersions && getFieldStatus('register.address', 'comparing') === 'removed' ? 'line-through' : 'none'">
                                        {{approval.register.address?.public_place
                                        ?
                                        approval.register.address?.public_place
                                        + ',
                                        ' :
                                        '--'}}
                                        {{approval.register.address?.number ?
                                        approval.register.address?.number + ', '
                                        :
                                        ''}}
                                        {{approval.register.address?.complement
                                        ?
                                        approval.register.address?.complement +
                                        ', '
                                        :
                                        ''}}
                                        {{approval.register.address?.district ?
                                        approval.register.address?.district + ',
                                        ' :
                                        ''}}
                                        {{approval.register.address?.city ?
                                        approval.register.address?.city + ' - '
                                        :
                                        ''}}
                                        {{approval.register.address?.uf ?
                                        approval.register.address?.uf : ''}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

            <app-spacer [bottom]="24"></app-spacer>
            <ng-container *ngIf="['complementary', 'all'].includes(activeTab)">
                <ng-container *ngIf="checkIsFund(approval.register)">
                    <div class="dash-details-card">
                        <div class="dash-details-card-header">
                            <span>E-mails de contato do fundo</span>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>

                        <div class="dash-details-card-body">
                            <div class="row">
                                <div class="col-12 d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Contato principal
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <ng-container
                                            *ngIf="approval.register.company?.contact_email && approval.register.company?.contact_email !== 'nan'
                                    && approval.register.company?.contact_email !== ' '; else noEmail">
                                            {{approval.register.company?.contact_email}}
                                        </ng-container>
                                        <ng-template #noEmail>
                                            <span>--</span>
                                        </ng-template>
                                    </span>
                                </div>
                            </div>
                            <app-spacer [bottom]="16"></app-spacer>

                            <div class="row">
                                <div class="col-12 d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Contato secundário
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        *ngFor="let email of approval.register.company?.secondary_email">
                                        {{email}}
                                    </span>

                                    <ng-container
                                        *ngIf="!approval.register.company?.secondary_email || approval.register.company?.secondary_email?.length === 0">
                                        <span>--</span>
                                    </ng-container>
                                    <app-spacer [top]="16"></app-spacer>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>

        <div class="col-12" [class.col-lg-8]="activeTab === 'complementary'"
            [class.col-lg-12]="['bank', 'economic-group', 'risk'].includes(activeTab)"
            *ngIf="['complementary', 'bank', 'economic-group', 'risk', 'all'].includes(activeTab)">
            <div class="row"
                *ngIf="hasRepresentativeRole && ['complementary', 'all'].includes(activeTab)">
                <div class="col-12">
                    <div class="dash-details-card">
                        <div class="dash-details-card-header">
                            <span>Representações</span>
                        </div>
                        <app-spacer [bottom]="25"></app-spacer>

                        <div class="table-container">
                            <table class="bank-data-table">
                                <thead>
                                    <tr>
                                        <th>Nome/Razão social</th>
                                        <th>Documento</th>
                                        <th>Precisa assinar</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of representativeData">
                                        <td>
                                            <span>{{ item.name }}</span>
                                        </td>
                                        <td>
                                            <span>{{ item.document }}</span>
                                        </td>
                                        <td>
                                            <svg-icon
                                                [src]="item.needsSignature ? 'assets/images/icon-check.svg' : 'assets/images/icon-times.svg'"
                                                [class]="item.needsSignature ? 'text-success' : 'text-danger'">
                                            </svg-icon>
                                        </td>
                                        <td>
                                            <svg-icon
                                                src="assets/images/icon-eye.svg"
                                                style="cursor: pointer;"
                                                (click)="openRepresentativeDetails(item.id)"></svg-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>
            <div class="row" *ngIf="!isOnlyRepresentative">
                <div class="col-12">
                    <ng-container
                        *ngIf="cardLoading.basic_data && ['complementary', 'all'].includes(activeTab)">
                        <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin: '0'
                        }">
                        </ngx-skeleton-loader>
                        <app-spacer [bottom]="24"></app-spacer>
                    </ng-container>

                    <div class="dash-details-card papers-card"
                        *ngIf="!cardLoading.basic_data && ['complementary', 'all'].includes(activeTab)">
                        <div class="dash-details-card-header">
                            <span>Papéis</span>
                        </div>
                        <app-spacer [bottom]="16"></app-spacer>

                        <ng-container *ngIf="!hasPapersForBasicTab()">
                            <div class="dash-details-card-body"
                                style="padding: 48px 20px; min-height: 160px;">
                                <app-empty-content [isVisible]="true"
                                    title="Nenhum papel encontrado"
                                    description="Não há papéis disponíveis para este registro."
                                    icon="/assets/images/forgot-password-icon2.png">
                                </app-empty-content>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="hasPapersForBasicTab()">
                            <div class="table-container papers-table-container">
                                <table class="papers-data-table">
                                    <thead>
                                        <tr>
                                            <th>Papel</th>
                                            <th>Status</th>
                                            <th>Homologado em</th>
                                            <th>Ativado em</th>
                                            <th>Inativado em</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container
                                            *ngFor="let paper of getBasicTabPapers(); let i = index">
                                            <tr>
                                                <td>
                                                    <div class="paper-cell-with-toggle">
                                                        <button type="button"
                                                            class="paper-reason-toggle"
                                                            *ngIf="hasPaperDetails(paper)"
                                                            (click)="togglePaperReason(i, paper)"
                                                            [attr.aria-label]="isPaperReasonExpanded(i, paper) ? 'Ocultar motivo do papel' : 'Exibir motivo do papel'"
                                                            [title]="isPaperReasonExpanded(i, paper) ? 'Ocultar motivo' : 'Exibir motivo'">
                                                            <svg-icon
                                                                src="assets/images/icon-right.svg"
                                                                class="paper-reason-toggle-icon"
                                                                [class.expanded]="isPaperReasonExpanded(i, paper)">
                                                            </svg-icon>
                                                        </button>
                                                        <span>{{
                                                            getPaperRoleLabel(paper)
                                                            }}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span
                                                        [class]="getPaperStatusBadgeClass(paper)">
                                                        {{
                                                        getPaperStatusLabel(paper)
                                                        }}
                                                    </span>
                                                </td>
                                                <td>{{
                                                    getPaperHomologatedAt(paper)
                                                    }}</td>
                                                <td>{{
                                                    getPaperActivatedAt(paper)
                                                    }}</td>
                                                <td>{{
                                                    getPaperInactivatedAt(paper)
                                                    }}</td>
                                            </tr>

                                            <tr class="paper-reason-row"
                                                *ngIf="hasPaperDetails(paper) && isPaperReasonExpanded(i, paper)">
                                                <td colspan="5">
                                                    <div class="paper-reason-content">
                                                        <ng-container *ngIf="hasPaperReason(paper)">
                                                            <span
                                                                class="paper-reason-label">{{getPaperReasonLabel(paper)}}</span>
                                                            <span>{{
                                                                getPaperReasonText(paper)
                                                                }}</span>
                                                        </ng-container>
                                                        <div>
                                                            <span
                                                                class="paper-reason-label">Usuário:</span>
                                                            <span>{{
                                                                getPaperActionUserName(paper)
                                                                }}</span>
                                                        </div>
                                                        <div>
                                                            <span
                                                                class="paper-reason-label">Documento:</span>
                                                            <span>{{
                                                                getPaperActionUserDocument(paper)
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </ng-container>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>

                    <ng-container *ngIf="cardLoading.bank_information">
                        <ngx-skeleton-loader [theme]="{
                        height: '244px'
                    }">
                        </ngx-skeleton-loader>
                    </ng-container>

                    <div class="dash-details-card">
                        <ng-container
                            *ngIf="!cardLoading.bank_information && ['complementary', 'bank', 'all'].includes(activeTab)">
                            <div class="dash-details-card-header">
                                <span>Contas bancárias</span>

                                <ng-container
                                    *ngIf="filteredFiles && filteredFiles.bank_account">
                                    <app-attachment-button
                                        [slugArr]="filteredFiles.bank_account"
                                        (onSelect)="handleSelect($event,'bank_account')">
                                    </app-attachment-button>
                                </ng-container>
                            </div>
                            <app-spacer [bottom]="25"></app-spacer>

                            <!-- Tabela de Dados Bancários -->
                            <div *ngIf="hasBankAccounts()"
                                class="table-container">
                                <table class="bank-data-table">
                                    <thead>
                                        <tr>
                                            <th>Banco</th>
                                            <th>Conta</th>
                                            <th>Tipo de conta</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of bankData">
                                            <td>
                                                <span>{{ item.bank.bank_code }}
                                                    - {{ item.bank.name
                                                    }}</span>
                                            </td>
                                            <td>
                                                Ag: {{ item.agency }} Conta: {{
                                                item.account_number }}{{
                                                item.account_digit ? '-' +
                                                item.account_digit : '' }}
                                            </td>
                                            <td>
                                                <span>{{
                                                    item.account_type_display ??
                                                    'Conta corrente' }}</span>
                                                <span *ngIf="item.main_account"
                                                    class="app-table-details-body-row-subtitle">{{
                                                    item.main_account ? 'Conta
                                                    principal' : '' }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Empty state quando não há contas bancárias -->
                            <ng-container *ngIf="!hasBankAccounts()">
                                <div class="dash-details-card-body"
                                    style="padding: 60px 20px; min-height: 200px;">
                                    <app-empty-content [isVisible]="true"
                                        title="Nenhuma conta bancária cadastrada"
                                        description="Não há informações de contas bancárias cadastradas para este registro."
                                        icon="/assets/images/forgot-password-icon2.png">
                                    </app-empty-content>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>

            <!-- Card Condição de Investidor (apenas para cotista PF e PJ) -->
            <!-- <ng-container
                *ngIf="isShareholder() && ['complementary', 'bank', 'all'].includes(activeTab)">
                <div class="row">
                    <div class="col-12">
                        <ng-container
                            *ngIf="!registrationExpirationInfo || !registrationExpirationInfo.raw">
                            <ngx-skeleton-loader [theme]="{
                                height: '244px'
                            }">
                            </ngx-skeleton-loader>
                        </ng-container>

                        <ng-container
                            *ngIf="registrationExpirationInfo && registrationExpirationInfo.raw">
                            <ng-container
                                *ngIf="getInvestorProfileData() as investorData">
                                <div class="dash-details-card">
                                    <div class="dash-details-card-header">
                                        <span>Condição de Investidor</span>
                                    </div>
                                    <app-spacer [bottom]="25"></app-spacer>

                                    <div class="dash-details-card-body">
                                        <div class="row">
                                            <div class="col-12 col-md-6">
                                                <div class="d-flex flex-column">
                                                    <span
                                                        class="dash-details-card-item-subtitle">
                                                        Qualificação
                                                    </span>
                                                    <span
                                                        class="dash-details-card-item-title">
                                                        {{renderQualificationLabel(investorData?.qualification)}}
                                                    </span>
                                                    <app-spacer
                                                        [bottom]="16"></app-spacer>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-6">
                                                <div class="d-flex flex-column">
                                                    <span
                                                        class="dash-details-card-item-subtitle">
                                                        Condição de Investidor
                                                    </span>
                                                    <span
                                                        class="dash-details-card-item-title">
                                                        {{renderInvestorConditionLabel(investorData?.investor_condition)}}
                                                    </span>
                                                    <app-spacer
                                                        [bottom]="16"></app-spacer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>
            </ng-container> -->

            <ng-container *ngIf="!isOnlyRepresentative">
                <ng-container *ngIf="cardLoading.pep_relationship">
                    <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                    </ngx-skeleton-loader>
                </ng-container>

                <ng-container *ngIf="!cardLoading.pep_relationship">
                    <div class="row">
                        <div class="col-12"
                            *ngIf="approval.register.type !== 'PJ'">
                            <div class="dash-details-card"
                                *ngIf="['complementary', 'all'].includes(activeTab)">
                                <div class="dash-details-card-header">
                                    <span>Possui relacionamento com PEP</span>
                                </div>
                                <app-spacer [bottom]="25"></app-spacer>

                                <div class="dash-details-card-body">
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Nome
                                                </span>
                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{getPepFieldDisplay('name')}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Documento
                                                </span>
                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{getPepFieldDisplay('document')}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>

                                        <div class="col-12 col-md-6">
                                            <div class="d-flex flex-column">
                                                <span
                                                    class="dash-details-card-item-subtitle">
                                                    Vínculo
                                                </span>
                                                <span
                                                    class="dash-details-card-item-title">
                                                    {{getPepFieldDisplay('bound')}}
                                                </span>
                                                <app-spacer
                                                    [bottom]="16"></app-spacer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                    </div>
                </ng-container>
            </ng-container>


            <div class="row">
                <ng-container *ngIf="cardLoading.economic_group">
                    <ngx-skeleton-loader [theme]="{
                        height: '244px',
                        margin:'0 0 24px'
                    }">
                    </ngx-skeleton-loader>
                </ng-container>

                <ng-container *ngIf="!cardLoading.economic_group">
                    <div class="col-12"
                        *ngIf="approval.register.type === 'PJ' && !checkIsFund(approval.register)">
                        <div class="dash-details-card"
                            *ngIf="['complementary', 'economic-group', 'all'].includes(activeTab)">
                            <div class="dash-details-card-header">
                                <span>Grupo econômico</span>

                                <ng-container
                                    *ngIf="filteredFiles && filteredFiles.economic_group">
                                    <app-attachment-button
                                        [slugArr]="filteredFiles.economic_group"
                                        (onSelect)="handleSelect($event,'economic_group')">
                                    </app-attachment-button>
                                </ng-container>
                            </div>
                            <app-spacer [bottom]="25"></app-spacer>

                            <!-- Tabela de Grupo Econômico -->
                            <div *ngIf="economicGroupData.length > 0"
                                class="table-container">
                                <table class="economic-group-table">
                                    <thead>
                                        <tr>
                                            <th
                                                style="text-transform:capitalize">
                                                Razão social</th>
                                            <th>CNPJ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="let item of economicGroupData">
                                            <td>{{
                                                item.corporate_name.toUpperCase()
                                                }}</td>
                                            <td>{{
                                                formatCnpj(item.company_document_number)
                                                }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- Empty state quando não há grupo econômico -->
                            <ng-container
                                *ngIf="economicGroupData.length === 0">
                                <div class="dash-details-card-body"
                                    style="padding: 60px 20px; min-height: 200px;">
                                    <app-empty-content [isVisible]="true"
                                        title="Nenhum grupo econômico cadastrado"
                                        description="Não há informações de grupo econômico cadastradas para este registro."
                                        icon="/assets/images/forgot-password-icon2.png">
                                    </app-empty-content>
                                </div>
                            </ng-container>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>

                    <div class="col-12"
                        *ngIf="approval.register.type === 'PJ' && checkIsFund(approval.register) && approval.register.company?.exclusive_fund && approval.register.company?.exclusive_fund_beneficiaries?.length > 0">
                        <div class="dash-details-card"
                            *ngIf="['complementary', 'economic-group', 'all'].includes(activeTab)">
                            <div class="dash-details-card-header">
                                <span>Beneficiários do fundo exclusivo</span>
                            </div>
                            <app-spacer [bottom]="25"></app-spacer>
                            <div class="table-container">
                                <table class="economic-group-table">
                                    <thead>
                                        <tr>
                                            <th
                                                style="text-transform:capitalize">
                                                Nome</th>
                                            <th>Documento</th>
                                            <th>Estrangeiro</th>
                                            <th>PEP</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="let b of approval.register.company.exclusive_fund_beneficiaries">
                                            <td>{{ b.name ?? '--' }}</td>
                                            <td>{{ b.document?.length === 11 ?
                                                formatCpf(b.document) :
                                                (b.document?.length === 14 ?
                                                formatCnpj(b.document) :
                                                (b.document ?? '--')) }}</td>
                                            <td>{{ b.document &&
                                                b.document.length !== 11 &&
                                                b.document.length !== 14 ? 'Sim'
                                                : 'Não' }}</td>
                                            <td>{{ b.is_pep ? 'Sim' : 'Não' }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <app-spacer [bottom]="24"></app-spacer>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <app-spacer [bottom]="24"></app-spacer>

</ng-container>

<!-- Visualização comparando versões (lado a lado) -->
<ng-container *ngIf="comparingVersions">
    <div class="row">
        <!-- Lado esquerdo - Versão Principal -->
        <div class="col-6">
            <ng-container
                *ngIf="approvalService.approvalData.mainVersion && approvalService.approvalData.mainRevision">
                <ng-container
                    *ngTemplateOutlet="versionTemplate; context: { versionType: 'main' }"></ng-container>
            </ng-container>
            <ng-container
                *ngIf="!approvalService.approvalData.mainVersion || !approvalService.approvalData.mainRevision">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>

        <!-- Lado direito - Versão Comparando -->
        <div class="col-6">
            <ng-container
                *ngIf="approvalService.approvalData.comparingVersion && approvalService.approvalData.comparingRevision">
                <ng-container
                    *ngTemplateOutlet="versionTemplate; context: { versionType: 'comparing' }"></ng-container>
            </ng-container>
            <ng-container
                *ngIf="!approvalService.approvalData.comparingVersion || !approvalService.approvalData.comparingRevision">
                <app-select-version-comparison></app-select-version-comparison>
            </ng-container>
        </div>
    </div>
</ng-container>

<!-- Template reutilizável para cada versão -->
<ng-template #versionTemplate let-versionType="versionType">
    <div class="col-12">
        <ng-container *ngIf="['complementary', 'all'].includes(activeTab)">
            <ng-container
                *ngIf="getCardLoadingForView(versionType)?.basic_data">
                <ngx-skeleton-loader [theme]="{
                            height: '468px',
                            margin:'0  0 24px'
                        }">
                </ngx-skeleton-loader>
            </ng-container>

            <div class="dash-details-card"
                *ngIf="!getCardLoadingForView(versionType)?.basic_data">
                <div class="dash-details-card-header">
                    <span>Dados básicos</span>

                    <ng-container
                        *ngIf="getFilteredFilesForView(versionType)?.basic_info">
                        <app-attachment-button
                            [slugArr]="getFilteredFilesForView(versionType)?.basic_info"
                            (onSelect)="handleSelect($event,'basic_info')">
                        </app-attachment-button>
                    </ng-container>
                </div>
                <app-spacer [bottom]="15"></app-spacer>

                <ng-container
                    *ngIf="getApprovalDataForView(versionType)?.register?.type === 'PJ' && getIsFundForView(versionType)">
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-column"
                                    [style.padding-bottom]="versionType === 'comparing' && getFieldStatus('register.company.document.number', versionType) !== 'unchanged' ? '8px' : '0'">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.document.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.document.number', versionType)"></span>
                                        <span>CNPJ</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.document.number', versionType)">
                                        {{getFieldValueForDisplay('register.company.document.number',
                                        getApprovalDataForView(versionType)?.register?.company.document.number,
                                        versionType)
                                        ?
                                        formatCnpj(getFieldValueForDisplay('register.company.document.number',
                                        getApprovalDataForView(versionType)?.register?.company.document.number,
                                        versionType))
                                        :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column"
                                    [style.padding-bottom]="versionType === 'comparing' && getFieldStatus('register.company.brand_name', versionType) !== 'unchanged' ? '8px' : '0'">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.brand_name', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.brand_name', versionType)"></span>
                                        <span>Nome Fantasia</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.brand_name', versionType)">
                                        {{getFieldValueForDisplay('register.company.brand_name',
                                        getApprovalDataForView(versionType)?.register?.company.brand_name,
                                        versionType)
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column"
                                    [style.padding-bottom]="versionType === 'comparing' && getFieldStatus('register.company.foundation_date', versionType) !== 'unchanged' ? '8px' : '0'">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.foundation_date', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.foundation_date', versionType)"></span>
                                        <span>Data da fundação</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.foundation_date', versionType)">
                                        {{getFieldValueForDisplay('register.company.foundation_date',
                                        getApprovalDataForView(versionType)?.register?.company.foundation_date,
                                        versionType)
                                        | date: 'dd/MM/yyyy' ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.branch_display', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.branch_display', versionType)"></span>
                                        <span>Forma de constituição</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getApprovalDataForView(versionType)?.register?.company.branch_display
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.framework.name', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.framework.name', versionType)"></span>
                                        <span>Natureza jurídica</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.framework.name', versionType)">
                                        {{getFieldValueForDisplay('register.company.framework.name',
                                        getApprovalDataForView(versionType)?.register?.company.framework?.name,
                                        versionType)
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.giin', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.giin', versionType)"></span>
                                        <span>GIIN</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.giin', versionType)">
                                        {{getFieldValueForDisplay('register.company.giin',
                                        getApprovalDataForView(versionType)?.register?.company.giin,
                                        versionType)
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.contract_type_display', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.contract_type_display', versionType)"></span>
                                        <span>Tipo de contrato</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getApprovalDataForView(versionType)?.register?.company.contract_type_display
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">

                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.cellphone.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.cellphone.number', versionType)"></span>
                                        <span>Celular</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.cellphone.number', versionType)">
                                        <a [href]="'tel:'+getFieldValueForDisplay('register.company.cellphone.number', getApprovalDataForView(versionType)?.register?.company.cellphone?.number, versionType)"
                                            target="_blank">
                                            {{formatPhone(getFieldValueForDisplay('register.company.cellphone.number',
                                            getApprovalDataForView(versionType)?.register?.company.cellphone?.number,
                                            versionType))
                                            ?? '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.phone.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.phone.number', versionType)"></span>
                                        <span>Telefone</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <a [href]="'tel:'+getApprovalDataForView(versionType)?.register?.company.phone?.number"
                                            target="_blank">
                                            {{formatPhone(getApprovalDataForView(versionType)?.register?.company.phone?.number)
                                            ?? '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.cnae.name', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.cnae.name', versionType)"></span>
                                        <span>CNAE</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.cnae.name', versionType)">
                                        <ng-container
                                            *ngIf="getFieldStatus('register.company.cnae.name', versionType) === 'removed'">
                                            {{mainApproval?.register?.company?.cnae?.name
                                            || '--'}}
                                        </ng-container>
                                        <ng-container
                                            *ngIf="getFieldStatus('register.company.cnae.name', versionType) !== 'removed'">
                                            {{getFieldValueForDisplay('register.company.cnae.name',
                                            getApprovalDataForView(versionType)?.register?.company.cnae?.name,
                                            versionType)
                                            ??
                                            '--'}}
                                        </ng-container>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.net_worth', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.net_worth', versionType)"></span>
                                        <span>Patrimônio líquido</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.net_worth', versionType)">
                                        {{getFieldValueForDisplay('register.company.net_worth',
                                        getApprovalDataForView(versionType)?.register?.company.net_worth,
                                        versionType)
                                        ?
                                        formatBrl(getFieldValueForDisplay('register.company.net_worth',
                                        getApprovalDataForView(versionType)?.register?.company.net_worth,
                                        versionType))
                                        :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <ng-container *ngIf="getIsFundForView(versionType)">
                                <div class="col-12">
                                    <div class="d-flex flex-column"
                                        [style.padding-bottom]="versionType === 'comparing' && getFieldStatus('register.company.exclusive_fund', versionType) !== 'unchanged' ? '8px' : '0'">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.exclusive_fund', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.exclusive_fund', versionType)"></span>
                                            <span>Trata-se de um fundo
                                                exclusivo?</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title"
                                            [ngClass]="getFieldStrikethroughClass('register.company.exclusive_fund', versionType)">
                                            {{getFieldValueForDisplay('register.company.exclusive_fund',
                                            getApprovalDataForView(versionType)?.register?.company.exclusive_fund,
                                            versionType)
                                            ? 'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>


                <ng-container
                    *ngIf="getApprovalDataForView(versionType)?.register?.type === 'PJ' && getIsSimplifiedForView(versionType)">
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.document.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.document.number', versionType)"></span>
                                        <span>CNPJ</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.document.number', versionType)">
                                        {{getFieldValueForDisplay('register.company.document.number',
                                        getApprovalDataForView(versionType)?.register?.company.document.number,
                                        versionType)
                                        ?
                                        formatCnpj(getFieldValueForDisplay('register.company.document.number',
                                        getApprovalDataForView(versionType)?.register?.company.document.number,
                                        versionType))
                                        :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.brand_name', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.brand_name', versionType)"></span>
                                        <span>Nome Fantasia</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.brand_name', versionType)">
                                        {{getFieldValueForDisplay('register.company.brand_name',
                                        getApprovalDataForView(versionType)?.register?.company.brand_name,
                                        versionType)
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Data de fundação
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.foundation_date', versionType)">
                                        {{getFieldValueForDisplay('register.company.foundation_date',
                                        getApprovalDataForView(versionType)?.register?.company.foundation_date,
                                        versionType)
                                        |
                                        date:
                                        'dd/MM/yyyy' ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.cnae.name', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.cnae.name', versionType)"></span>
                                        <span>CNAE</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.cnae.name', versionType)">
                                        <ng-container
                                            *ngIf="getFieldStatus('register.company.cnae.name', versionType) === 'removed'">
                                            {{mainApproval?.register?.company?.cnae?.name
                                            || '--'}}
                                        </ng-container>
                                        <ng-container
                                            *ngIf="getFieldStatus('register.company.cnae.name', versionType) !== 'removed'">
                                            {{getFieldValueForDisplay('register.company.cnae.name',
                                            getApprovalDataForView(versionType)?.register?.company.cnae?.name,
                                            versionType)
                                            ??
                                            '--'}}
                                        </ng-container>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.capital', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.capital', versionType)"></span>
                                        <span>capital social</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getApprovalDataForView(versionType)?.register?.company.capital
                                        ?
                                        formatBrl(getApprovalDataForView(versionType)?.register?.company.capital)
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.yearly_income', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.yearly_income', versionType)"></span>
                                        <span>faturamento bruto anual</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{formatBrl(getApprovalDataForView(versionType)?.register?.company.yearly_income)
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.number_employees', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.number_employees', versionType)"></span>
                                        <span>N.º de funcionários</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getApprovalDataForView(versionType)?.register?.company.number_employees
                                        ?
                                        getEmployeesName(getApprovalDataForView(versionType)?.register?.company.number_employees)
                                        :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container
                    *ngIf="getApprovalDataForView(versionType)?.register?.type === 'PJ' && !getIsSimplifiedForView(versionType) && !getIsFundForView(versionType)">
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.document.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.document.number', versionType)"></span>
                                        <span>CNPJ</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.document.number', versionType)">
                                        {{getFieldValueForDisplay('register.company.document.number',
                                        getApprovalDataForView(versionType)?.register?.company.document?.number,
                                        versionType)
                                        ?
                                        formatCnpj(getFieldValueForDisplay('register.company.document.number',
                                        getApprovalDataForView(versionType)?.register?.company.document?.number,
                                        versionType))
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.brand_name', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.brand_name', versionType)"></span>
                                        <span>Nome Fantasia</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.brand_name', versionType)">
                                        {{getFieldValueForDisplay('register.company.brand_name',
                                        getApprovalDataForView(versionType)?.register?.company.brand_name,
                                        versionType)
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column"
                                    [style.padding-bottom]="versionType === 'comparing' && getFieldStatus('register.company.foundation_date', versionType) !== 'unchanged' ? '8px' : '0'">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.foundation_date', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.foundation_date', versionType)"></span>
                                        <span>Data de fundação</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.foundation_date', versionType)">
                                        {{getFieldValueForDisplay('register.company.foundation_date',
                                        getApprovalDataForView(versionType)?.register?.company.foundation_date,
                                        versionType)
                                        |
                                        date:
                                        'dd/MM/yyyy' ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.branch_display', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.branch_display', versionType)"></span>
                                        <span>Forma de constituição</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getApprovalDataForView(versionType)?.register?.company.branch_display
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.framework.name', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.framework.name', versionType)"></span>
                                        <span>Natureza jurídica</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.framework.name', versionType)">
                                        {{getFieldValueForDisplay('register.company.framework.name',
                                        getApprovalDataForView(versionType)?.register?.company.framework?.name,
                                        versionType)
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <ng-container
                                *ngIf="!getIsFundForView(versionType)">
                                <div class="col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.municipal_registration', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.municipal_registration', versionType)"></span>
                                            <span>Inscrição municipal</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getApprovalDataForView(versionType)?.register?.company.municipal_registration
                                            ??
                                            '--'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.state_registration', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.state_registration', versionType)"></span>
                                            <span>Inscrição estadual</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getApprovalDataForView(versionType)?.register?.company.state_registration
                                            ??
                                            '--'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.free_state_registration', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.free_state_registration', versionType)"></span>
                                            <span>Isento de inscrição
                                                estadual</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getApprovalDataForView(versionType)?.register?.company.free_state_registration
                                            ? 'Sim': 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.nire', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.nire', versionType)"></span>
                                            <span>NIRE</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getApprovalDataForView(versionType)?.register?.company.nire
                                            ??
                                            '--'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </ng-container>

                            <div class="col-md-6"
                                *ngIf="hasAnyRole(['assignor', 'provider'], versionType) && !getIsFundForView(versionType)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.giin', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.giin', versionType)"></span>
                                        <span>GIIN</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.giin', versionType)">
                                        {{getFieldValueForDisplay('register.company.giin',
                                        getApprovalDataForView(versionType)?.register?.company.giin,
                                        versionType)
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6"
                                *ngIf="!getIsFundForView(versionType)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.contract_type_display', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.contract_type_display', versionType)"></span>
                                        <span>Tipo de contrato</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getApprovalDataForView(versionType)?.register?.company.contract_type
                                        ?
                                        renderContractType(getApprovalDataForView(versionType)?.register?.company.contract_type):
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.cellphone.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.cellphone.number', versionType)"></span>
                                        <span>Celular</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.cellphone.number', versionType)">
                                        <a [href]="'tel:'+getFieldValueForDisplay('register.company.cellphone.number', getApprovalDataForView(versionType)?.register?.company.cellphone?.number, versionType)"
                                            target="_blank">
                                            {{formatPhone(getFieldValueForDisplay('register.company.cellphone.number',
                                            getApprovalDataForView(versionType)?.register?.company.cellphone?.number,
                                            versionType))
                                            ?? '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.phone.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.phone.number', versionType)"></span>
                                        <span>Telefone</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <a [href]="'tel:'+getApprovalDataForView(versionType)?.register?.company.phone?.number"
                                            target="_blank">
                                            {{formatPhone(getApprovalDataForView(versionType)?.register?.company.phone?.number)
                                            ?? '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12"
                                *ngIf="!getIsFundForView(versionType)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.contact_email', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.contact_email', versionType)"></span>
                                        <span>Email</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <a [href]="'mailto:'+getApprovalDataForView(versionType)?.register?.company?.contact_email"
                                            target="_blank">
                                            {{getApprovalDataForView(versionType)?.register?.company?.contact_email
                                            &&
                                            getApprovalDataForView(versionType)?.register?.company?.contact_email
                                            !== ' '
                                            ?
                                            getApprovalDataForView(versionType)?.register?.company?.contact_email
                                            :
                                            '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12"
                                *ngIf="!getIsFundForView(versionType)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.site', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.site', versionType)"></span>
                                        <span>Site</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        <a [href]="getApprovalDataForView(versionType)?.register?.company.site"
                                            target="_blank">
                                            {{getApprovalDataForView(versionType)?.register?.company.site
                                            &&
                                            getApprovalDataForView(versionType)?.register?.company.site
                                            !== '
                                            ' ?
                                            getApprovalDataForView(versionType)?.register?.company.site
                                            :
                                            '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.cnae.name', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.cnae.name', versionType)"></span>
                                        <span>CNAE</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.company.cnae.name', versionType)">
                                        <ng-container
                                            *ngIf="getFieldStatus('register.company.cnae.name', versionType) === 'removed'">
                                            {{mainApproval?.register?.company?.cnae?.name
                                            || '--'}}
                                        </ng-container>
                                        <ng-container
                                            *ngIf="getFieldStatus('register.company.cnae.name', versionType) !== 'removed'">
                                            {{getFieldValueForDisplay('register.company.cnae.name',
                                            getApprovalDataForView(versionType)?.register?.company.cnae?.name,
                                            versionType)
                                            ??
                                            '--'}}
                                        </ng-container>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6"
                                *ngIf="!getIsFundForView(versionType)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.company.company_size_display', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.company.company_size_display', versionType)"></span>
                                        <span>PORTE</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getApprovalDataForView(versionType)?.register?.company.company_size_display
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6"
                                *ngIf="!getIsFundForView(versionType)">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        N.º de funcionários
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getApprovalDataForView(versionType)?.register?.company.number_employees
                                        ?
                                        getEmployeesName(getApprovalDataForView(versionType)?.register?.company.number_employees)
                                        :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <ng-container
                                *ngIf="hasAnyRole(['assignor'], versionType) || hasShareholderRole(versionType)">
                                <div class="col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.yearly_income', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.yearly_income', versionType)"></span>
                                            <span>faturamento bruto anual</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getApprovalDataForView(versionType)?.register?.company.yearly_income
                                            ?
                                            formatBrl(getApprovalDataForView(versionType)?.register?.company.yearly_income)
                                            : '--'}}
                                        </span>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.capital', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.capital', versionType)"></span>
                                            <span>capital social</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getApprovalDataForView(versionType)?.register?.company.capital
                                            ?
                                            formatBrl(getApprovalDataForView(versionType)?.register?.company.capital)
                                            :
                                            '--'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <ng-container *ngIf="hasAnyRole(['assignor'], versionType)">
                        <div class="divider"></div>
                        <app-spacer [bottom]="30"></app-spacer>

                        <div class="dash-details-card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.assignor.joint_obligation', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.assignor.joint_obligation', versionType)"></span>
                                            <span>coobrigação</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getApprovalDataForView(versionType)?.register?.company.assignor?.joint_obligation
                                            === "true"
                                            ? 'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.judicial_recovery', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.judicial_recovery', versionType)"></span>
                                            <span>Em recuperação judicial</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getApprovalDataForView(versionType)?.register?.company.judicial_recovery
                                            ? 'Sim' : 'Não'}}
                                            <ng-container
                                                *ngIf="getApprovalDataForView(versionType)?.register?.company.judicial_recovery_date">
                                                ,
                                                {{getApprovalDataForView(versionType)?.register?.company.judicial_recovery_date
                                                | date: 'dd/MM/yyyy'}}
                                            </ng-container>
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.billet_emitter', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.billet_emitter', versionType)"></span>
                                            <span>Emite boleto</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getApprovalDataForView(versionType)?.register?.company.billet_emitter
                                            ?
                                            'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.nfe_emitter', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.nfe_emitter', versionType)"></span>
                                            <span>Emite NFe</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getApprovalDataForView(versionType)?.register?.company.nfe_emitter
                                            ?
                                            'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.duplicate_emitter', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.duplicate_emitter', versionType)"></span>
                                            <span>Emite duplicata</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getApprovalDataForView(versionType)?.register?.company.duplicate_emitter
                                            ? 'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.company.sfn', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.company.sfn', versionType)"></span>
                                            <span>Faz parte do SFN</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getFieldValueForDisplay('register.company.sfn',
                                            getApprovalDataForView(versionType)?.register?.company.sfn,
                                            versionType)
                                            ? 'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <ng-container
                    *ngIf="getApprovalDataForView(versionType)?.register?.type === 'PF' && !getIsSimplifiedForView(versionType) ">
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.document.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.document.number', versionType)"></span>
                                        <span>CPF</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.document.number', versionType)">
                                        {{getFieldValueForDisplay('register.person.document.number',
                                        getApprovalDataForView(versionType)?.register?.person.document?.number,
                                        versionType)
                                        ?
                                        formatCpf(getFieldValueForDisplay('register.person.document.number',
                                        getApprovalDataForView(versionType)?.register?.person.document?.number,
                                        versionType))
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>


                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.birth_date', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.birth_date', versionType)"></span>
                                        <span>DATA DE NASCIMENTO</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.birth_date', versionType)">
                                        {{getFieldValueForDisplay('register.person.birth_date',
                                        getApprovalDataForView(versionType)?.register?.person.birth_date,
                                        versionType) ?
                                        (getFieldValueForDisplay('register.person.birth_date',
                                        getApprovalDataForView(versionType)?.register?.person.birth_date,
                                        versionType) | date: 'dd/MM/yyyy') :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.nationality', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.nationality', versionType)"></span>
                                        <span>País de origem</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.nationality', versionType)">
                                        {{getFieldValueForDisplay('register.person.nationality',
                                        getApprovalDataForView(versionType)?.register?.person.nationality,
                                        versionType)
                                        ?
                                        getNationalityDisplay(getFieldValueForDisplay('register.person.nationality',
                                        getApprovalDataForView(versionType)?.register?.person.nationality,
                                        versionType))
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.naturalness', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.naturalness', versionType)"></span>
                                        <span>Naturalidade (UF)</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.naturalness', versionType)">
                                        {{getFieldValueForDisplay('register.person.naturalness',
                                        getApprovalDataForView(versionType)?.register?.person.naturalness,
                                        versionType)
                                        ?
                                        getStateDisplayName(getFieldValueForDisplay('register.person.naturalness',
                                        getApprovalDataForView(versionType)?.register?.person.naturalness,
                                        versionType))
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.naturalness_city', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.naturalness_city', versionType)"></span>
                                        <span>Naturalidade (Cidade)</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.naturalness_city', versionType)">
                                        {{getFieldValueForDisplay('register.person.naturalness_city',
                                        getApprovalDataForView(versionType)?.register?.person.naturalness_city,
                                        versionType)
                                        ?
                                        (getFieldValueForDisplay('register.person.naturalness_city',
                                        getApprovalDataForView(versionType)?.register?.person.naturalness_city,
                                        versionType)?.name ?? '--')
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.gender', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.gender', versionType)"></span>
                                        <span>Gênero</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.gender', versionType)">
                                        {{
                                        getChoicesName('gender_choices',
                                        getFieldValueForDisplay('register.person.gender',
                                        getApprovalDataForView(versionType)?.register?.person.gender,
                                        versionType))?.label
                                        ?? '--'
                                        }}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.marital_status', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.marital_status', versionType)"></span>
                                        <span>Estado civil</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.marital_status', versionType)">
                                        {{
                                        getChoicesName('marital_choices',
                                        getFieldValueForDisplay('register.person.marital_status',
                                        getApprovalDataForView(versionType)?.register?.person.marital_status,
                                        versionType))?.label
                                        ?? '--'
                                        }}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.spouse.document', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.spouse.document', versionType)"></span>
                                        <span>CPF DO CÔNJUGE</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.spouse.document', versionType)">
                                        {{getFieldValueForDisplay('register.person.spouse.document',
                                        getApprovalDataForView(versionType)?.register?.person.spouse?.document,
                                        versionType)
                                        ?
                                        formatCpf(getFieldValueForDisplay('register.person.spouse.document',
                                        getApprovalDataForView(versionType)?.register?.person.spouse?.document,
                                        versionType))
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.spouse.name', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.spouse.name', versionType)"></span>
                                        <span>NOME DO CÔNJUGE</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.spouse.name', versionType)">
                                        {{getFieldValueForDisplay('register.person.spouse.name',
                                        getApprovalDataForView(versionType)?.register?.person.spouse?.name,
                                        versionType)
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            [innerHTML]="getFieldComparisonIcon('register.person.spouse.marriage_bond', versionType)"></span>
                                        <span>REGIME DE CASAMENTO</span>
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getApprovalDataForView(versionType)?.register?.person.spouse
                                        &&
                                        getApprovalDataForView(versionType)?.register?.person.spouse.marriage_bond
                                        ?
                                        getChoicesName('marital_statutes',getApprovalDataForView(versionType)?.register?.person.spouse.marriage_bond)?.label
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.mother_name', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.mother_name', versionType)"></span>
                                        <span>NOME DA MÃE</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.mother_name', versionType)">
                                        {{getFieldValueForDisplay('register.person.mother_name',
                                        getApprovalDataForView(versionType)?.register?.person.mother_name,
                                        versionType)
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.father_name', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.father_name', versionType)"></span>
                                        <span>NOME DO PAI</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.father_name', versionType)">
                                        {{getFieldValueForDisplay('register.person.father_name',
                                        getApprovalDataForView(versionType)?.register?.person.father_name,
                                        versionType)
                                        ??
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">

                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle">
                                        Tipo de documento
                                    </span>

                                    <span class="dash-details-card-item-title">
                                        {{getApprovalDataForView(versionType)?.register?.person.secondary_document?.type.name
                                        ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.secondary_document.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.secondary_document.number', versionType)"></span>
                                        <span>Número do documento</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.secondary_document.number', versionType)">
                                        {{getFieldValueForDisplay('register.person.secondary_document.number',
                                        getApprovalDataForView(versionType)?.register?.person.secondary_document?.number,
                                        versionType)
                                        &&
                                        getApprovalDataForView(versionType)?.register?.person.secondary_document
                                        ?
                                        handleFormatDocument(getApprovalDataForView(versionType)?.register?.person.secondary_document)
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.secondary_document.dispatching_agency', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.secondary_document.dispatching_agency', versionType)"></span>
                                        <span>Órgão expedidor</span>
                                    </span>
                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.secondary_document.dispatching_agency', versionType)">
                                        <ng-container *ngIf="getFieldValueForDisplay('register.person.secondary_document.uf',
                                        getApprovalDataForView(versionType)?.register?.person.secondary_document?.uf,
                                        versionType)">
                                            {{getFieldValueForDisplay('register.person.secondary_document.uf',
                                            getApprovalDataForView(versionType)?.register?.person.secondary_document?.uf,
                                            versionType)}}
                                            /
                                        </ng-container>
                                        {{getFieldValueForDisplay('register.person.secondary_document.dispatching_agency',
                                        getApprovalDataForView(versionType)?.register?.person.secondary_document?.dispatching_agency,
                                        versionType)
                                        ?
                                        getFieldValueForDisplay('register.person.secondary_document.dispatching_agency',
                                        getApprovalDataForView(versionType)?.register?.person.secondary_document?.dispatching_agency,
                                        versionType)
                                        :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.secondary_document.expedition_date', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.secondary_document.expedition_date', versionType)"></span>
                                        <span>Data de expedição</span>
                                    </span>
                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.secondary_document.expedition_date', versionType)">
                                        <ng-container *ngIf="getFieldValueForDisplay('register.person.secondary_document.expedition_date',
                                        getApprovalDataForView(versionType)?.register?.person.secondary_document?.expedition_date,
                                        versionType)">
                                            {{getFieldValueForDisplay('register.person.secondary_document.expedition_date',
                                            getApprovalDataForView(versionType)?.register?.person.secondary_document?.expedition_date,
                                            versionType)
                                            | date: 'dd/MM/yyyy'}}
                                        </ng-container>
                                        <ng-container *ngIf="!getFieldValueForDisplay('register.person.secondary_document.expedition_date',
                                        getApprovalDataForView(versionType)?.register?.person.secondary_document?.expedition_date,
                                        versionType)">
                                            --
                                        </ng-container>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.cellphone.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.cellphone.number', versionType)"></span>
                                        <span>Celular</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.cellphone.number', versionType)">
                                        <a [href]="'tel:'+getFieldValueForDisplay('register.person.cellphone.number',
                                    getApprovalDataForView(versionType)?.register?.person.cellphone?.number,
                                    versionType)" target="_blank">
                                            {{formatPhone(getFieldValueForDisplay('register.person.cellphone.number',
                                            getApprovalDataForView(versionType)?.register?.person.cellphone?.number,
                                            versionType))
                                            ?? '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.phone.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.phone.number', versionType)"></span>
                                        <span>Telefone</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.phone.number', versionType)">
                                        <a [href]="'tel:'+getFieldValueForDisplay('register.person.phone.number',
                                    getApprovalDataForView(versionType)?.register?.person.phone?.number,
                                    versionType)" target="_blank">
                                            {{formatPhone(getFieldValueForDisplay('register.person.phone.number',
                                            getApprovalDataForView(versionType)?.register?.person.phone?.number,
                                            versionType))
                                            ?? '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.email', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.email', versionType)"></span>
                                        <span>Email</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.email', versionType)">
                                        <a [href]="'mailto:'+getFieldValueForDisplay('register.person.email',
                                    getApprovalDataForView(versionType)?.register?.person.email,
                                    versionType)" target="_blank">
                                            {{getFieldValueForDisplay('register.person.email',
                                            getApprovalDataForView(versionType)?.register?.person.email,
                                            versionType)
                                            ??
                                            '--'}}
                                        </a>
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <ng-container
                                *ngIf="hasAnyRole(['assignor', 'provider'], versionType)">
                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.person.site', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.person.site', versionType)"></span>
                                            <span>Site</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title"
                                            [ngClass]="getFieldStrikethroughClass('register.person.site', versionType)">
                                            <a [href]="getFieldValueForDisplay('register.person.site',
                                        getApprovalDataForView(versionType)?.register?.person.site,
                                        versionType)" target="_blank">
                                                {{getFieldValueForDisplay('register.person.site',
                                                getApprovalDataForView(versionType)?.register?.person.site,
                                                versionType)
                                                &&
                                                getFieldValueForDisplay('register.person.site',
                                                getApprovalDataForView(versionType)?.register?.person.site,
                                                versionType)
                                                !== ' ' ?
                                                getFieldValueForDisplay('register.person.site',
                                                getApprovalDataForView(versionType)?.register?.person.site,
                                                versionType)
                                                :
                                                '--'}}
                                            </a>
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.person.revenues', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.person.revenues', versionType)"></span>
                                            <span>Rendimento dos últimos 12
                                                meses</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title"
                                            [ngClass]="getFieldStrikethroughClass('register.person.revenues', versionType)">
                                            {{formatBrl(getFieldValueForDisplay('register.person.revenues',
                                            getApprovalDataForView(versionType)?.register?.person.revenues,
                                            versionType))
                                            ??
                                            '--'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container
                                *ngIf="hasAnyRole(['assignor'], versionType)">
                                <div class="col-12">
                                    <div class="d-flex flex-column">
                                        <span
                                            class="dash-details-card-item-subtitle"
                                            style="display: flex; align-items: center; gap: 6px;">
                                            <span
                                                *ngIf="hasFieldComparisonIcon('register.person.sfn', versionType)"
                                                [innerHTML]="getFieldComparisonIcon('register.person.sfn', versionType)"></span>
                                            <span>Faz parte do SFN</span>
                                        </span>

                                        <span
                                            class="dash-details-card-item-title">
                                            {{getFieldValueForDisplay('register.person.sfn',
                                            getApprovalDataForView(versionType)?.register?.person.sfn,
                                            versionType)
                                            ? 'Sim' : 'Não'}}
                                        </span>
                                        <app-spacer [bottom]="16"></app-spacer>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>
                </ng-container>


                <ng-container
                    *ngIf="getApprovalDataForView(versionType)?.register?.type === 'PF' && getIsSimplifiedForView(versionType) ">
                    <div class="dash-details-card-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.document.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.document.number', versionType)"></span>
                                        <span>CPF</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.document.number', versionType)">
                                        {{getFieldValueForDisplay('register.person.document.number',
                                        getApprovalDataForView(versionType)?.register?.person.document?.number,
                                        versionType)
                                        ?
                                        formatCpf(getFieldValueForDisplay('register.person.document.number',
                                        getApprovalDataForView(versionType)?.register?.person.document?.number,
                                        versionType))
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.birth_date', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.birth_date', versionType)"></span>
                                        <span>DATA DE NASCIMENTO</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.birth_date', versionType)">
                                        {{getFieldValueForDisplay('register.person.birth_date',
                                        getApprovalDataForView(versionType)?.register?.person.birth_date,
                                        versionType) ?
                                        (getFieldValueForDisplay('register.person.birth_date',
                                        getApprovalDataForView(versionType)?.register?.person.birth_date,
                                        versionType) | date: 'dd/MM/yyyy') :
                                        '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.nationality', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.nationality', versionType)"></span>
                                        <span>País de origem</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.nationality', versionType)">
                                        {{getFieldValueForDisplay('register.person.nationality',
                                        getApprovalDataForView(versionType)?.register?.person.nationality,
                                        versionType)
                                        ?
                                        getNationalityDisplay(getFieldValueForDisplay('register.person.nationality',
                                        getApprovalDataForView(versionType)?.register?.person.nationality,
                                        versionType))
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.document.number', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.document.number', versionType)"></span>
                                        <span>DOCUMENTO</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.document.number', versionType)">
                                        {{getFieldValueForDisplay('register.person.document.number',
                                        getApprovalDataForView(versionType)?.register?.person.document?.number,
                                        versionType)
                                        ?
                                        formatCpf(getFieldValueForDisplay('register.person.document.number',
                                        getApprovalDataForView(versionType)?.register?.person.document?.number,
                                        versionType))
                                        : '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.document.expedition_date', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.document.expedition_date', versionType)"></span>
                                        <span>DATA DE EXPEDIÇÃO</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.document.expedition_date', versionType)">
                                        {{getFieldValueForDisplay('register.person.document.expedition_date',
                                        getApprovalDataForView(versionType)?.register?.person.document.expedition_date,
                                        versionType)
                                        | date:'dd/MM/yyyy' ?? '--'}}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="d-flex flex-column">
                                    <span
                                        class="dash-details-card-item-subtitle"
                                        style="display: flex; align-items: center; gap: 6px;">
                                        <span
                                            *ngIf="hasFieldComparisonIcon('register.person.gender', versionType)"
                                            [innerHTML]="getFieldComparisonIcon('register.person.gender', versionType)"></span>
                                        <span>Gênero</span>
                                    </span>

                                    <span class="dash-details-card-item-title"
                                        [ngClass]="getFieldStrikethroughClass('register.person.gender', versionType)">
                                        {{
                                        getChoicesName('gender_choices',
                                        getFieldValueForDisplay('register.person.gender',
                                        getApprovalDataForView(versionType)?.register?.person.gender,
                                        versionType))?.label
                                        ?? '--'
                                        }}
                                    </span>
                                    <app-spacer [bottom]="16"></app-spacer>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>

    <app-spacer [bottom]="24"></app-spacer>

    <ng-container *ngIf="['complementary', 'all'].includes(activeTab)">
        <ng-container *ngIf="getCardLoadingForView(versionType)?.basic_data">
            <ngx-skeleton-loader [theme]="{
                        height: '468px',
                        margin:'0'
                      }">
            </ngx-skeleton-loader>
        </ng-container>

        <ng-container
            *ngIf="!getIsSimplifiedForView(versionType) && !getIsFundForView(versionType) && !getCardLoadingForView(versionType)?.basic_data">
            <div class="dash-details-card address-card">
                <div class="dash-details-card-header">
                    <span>Endereço</span>

                    <ng-container
                        *ngIf="getFilteredFilesForView(versionType)?.address">
                        <app-attachment-button
                            [slugArr]="getFilteredFilesForView(versionType)?.address"
                            (onSelect)="handleSelect($event,'address')">
                        </app-attachment-button>
                    </ng-container>
                </div>
                <app-spacer [bottom]="24"></app-spacer>

                <div class="dash-details-card-body">
                    <div class="row">
                        <div class="col-12 d-flex flex-column">
                            <span class="dash-details-card-item-subtitle"
                                style="display: flex; align-items: center; gap: 6px;">
                                <span
                                    *ngIf="hasFieldComparisonIcon('register.address.cep', versionType)"
                                    [innerHTML]="getFieldComparisonIcon('register.address.cep', versionType)"></span>
                                <span>CEP</span>
                            </span>

                            <span class="dash-details-card-item-title"
                                [ngClass]="getFieldAllClasses('register.address.cep', versionType)"
                                [style.text-decoration]="versionType === 'comparing' && getFieldStatus('register.address.cep', versionType) === 'removed' ? 'line-through' : 'none'">
                                {{getFieldValueForDisplay('register.address.cep',
                                getApprovalDataForView(versionType)?.register?.address?.cep,
                                versionType)
                                ?? '--'}}
                            </span>
                            <app-spacer [bottom]="16"></app-spacer>
                        </div>

                        <div class="col-12 d-flex flex-column">
                            <span class="dash-details-card-item-subtitle"
                                style="display: flex; align-items: center; gap: 6px;">
                                <span
                                    *ngIf="hasFieldComparisonIcon('register.address', versionType)"
                                    [innerHTML]="getFieldComparisonIcon('register.address', versionType)"></span>
                                <span>ENDEREÇO COMPLETO</span>
                            </span>

                            <span class="dash-details-card-item-title"
                                [ngClass]="getFieldAllClasses('register.address', versionType)">
                                <ng-container
                                    *ngIf="versionType === 'comparing' && getFieldStatus('register.address', versionType) === 'removed'">
                                    {{getMainValueForComparison('register.address')?.public_place
                                    ?
                                    getMainValueForComparison('register.address')?.public_place
                                    + ', ' : '--'}}
                                    {{getMainValueForComparison('register.address')?.number
                                    ?
                                    getMainValueForComparison('register.address')?.number
                                    + ', ' : ''}}
                                    {{getMainValueForComparison('register.address')?.complement
                                    ?
                                    getMainValueForComparison('register.address')?.complement
                                    + ', ' : ''}}
                                    {{getMainValueForComparison('register.address')?.district
                                    ?
                                    getMainValueForComparison('register.address')?.district
                                    + ', ' : ''}}
                                    {{getMainValueForComparison('register.address')?.city
                                    ?
                                    getMainValueForComparison('register.address')?.city
                                    + ' - ' : ''}}
                                    {{getMainValueForComparison('register.address')?.uf
                                    || ''}}
                                </ng-container>
                                <ng-container
                                    *ngIf="versionType !== 'comparing' || getFieldStatus('register.address', versionType) !== 'removed'">
                                    {{getApprovalDataForView(versionType)?.register?.address?.public_place
                                    ?
                                    getApprovalDataForView(versionType)?.register?.address?.public_place
                                    + ', ' : '--'}}
                                    {{getApprovalDataForView(versionType)?.register?.address?.number
                                    ?
                                    getApprovalDataForView(versionType)?.register?.address?.number
                                    + ', ' : ''}}
                                    {{getApprovalDataForView(versionType)?.register?.address?.complement
                                    ?
                                    getApprovalDataForView(versionType)?.register?.address?.complement
                                    + ', ' : ''}}
                                    {{getApprovalDataForView(versionType)?.register?.address?.district
                                    ?
                                    getApprovalDataForView(versionType)?.register?.address?.district
                                    + ', ' : ''}}
                                    {{getApprovalDataForView(versionType)?.register?.address?.city
                                    ?
                                    getApprovalDataForView(versionType)?.register?.address?.city
                                    + ' - ' : ''}}
                                    {{getApprovalDataForView(versionType)?.register?.address?.uf
                                    || ''}}
                                </ng-container>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <app-spacer [bottom]="24"></app-spacer>

        <ng-container *ngIf="getIsFundForView(versionType)">
            <div class="dash-details-card">
                <div class="dash-details-card-header">
                    <span>E-mails de contato do fundo</span>
                </div>
                <app-spacer [bottom]="24"></app-spacer>

                <div class="dash-details-card-body">
                    <div class="row">
                        <div class="col-12 d-flex flex-column">
                            <span class="dash-details-card-item-subtitle">
                                Contato principal
                            </span>

                            <span class="dash-details-card-item-title">
                                <ng-container
                                    *ngIf="getApprovalDataForView(versionType)?.register?.company?.contact_email && getApprovalDataForView(versionType)?.register?.company?.contact_email !== 'nan'
                                    && getApprovalDataForView(versionType)?.register?.company?.contact_email !== ' '; else noEmail">
                                    {{getApprovalDataForView(versionType)?.register?.company?.contact_email}}
                                </ng-container>
                                <ng-template #noEmail>
                                    <span>--</span>
                                </ng-template>
                            </span>
                        </div>
                    </div>
                    <app-spacer [bottom]="16"></app-spacer>

                    <div class="row">
                        <div class="col-12 d-flex flex-column">
                            <span class="dash-details-card-item-subtitle">
                                Contato secundário
                            </span>

                            <span class="dash-details-card-item-title"
                                *ngFor="let email of getApprovalDataForView(versionType)?.register?.company?.secondary_email">
                                {{email}}
                            </span>

                            <ng-container
                                *ngIf="!getApprovalDataForView(versionType)?.register?.company?.secondary_email || getApprovalDataForView(versionType)?.register?.company?.secondary_email?.length === 0">
                                <span>--</span>
                            </ng-container>
                            <app-spacer [top]="16"></app-spacer>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="col-12">
            <div class="row" *ngIf="!isOnlyRepresentative">
                <div class="col-12">
                    <div class="dash-details-card papers-card"
                        *ngIf="!getCardLoadingForView(versionType)?.basic_data && ['complementary', 'all'].includes(activeTab)">
                        <div class="dash-details-card-header">
                            <span>Papéis</span>
                        </div>
                        <app-spacer [bottom]="16"></app-spacer>

                        <ng-container *ngIf="!hasPapersForView(versionType)">
                            <div class="dash-details-card-body"
                                style="padding: 48px 20px; min-height: 160px;">
                                <app-empty-content [isVisible]="true"
                                    title="Nenhum papel encontrado"
                                    description="Não há papéis disponíveis para este registro."
                                    icon="/assets/images/forgot-password-icon2.png">
                                </app-empty-content>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="hasPapersForView(versionType)">
                            <div class="table-container papers-table-container">
                                <table class="papers-data-table">
                                    <thead>
                                        <tr>
                                            <th>Papel</th>
                                            <th>Status</th>
                                            <th>Homologado em</th>
                                            <th>Ativado em</th>
                                            <th>Inativado em</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container
                                            *ngFor="let paper of getPapersForComparison(versionType); let i = index">
                                            <tr
                                                [ngClass]="comparingVersions && versionType === 'comparing' ? getTableItemRowClass(getPaperItemStatus(paper, versionType), versionType) : ''">
                                                <td>
                                                    <div class="paper-cell-with-toggle"
                                                        [style.text-decoration]="comparingVersions && versionType === 'comparing' && getPaperItemStatus(paper, versionType) === 'removed' ? 'line-through' : 'none'">
                                                        <span
                                                            *ngIf="comparingVersions && versionType === 'comparing' && getTableItemIcon(getPaperFieldStatus('role', paper, versionType), versionType)"
                                                            [innerHTML]="getTableItemIcon(getPaperFieldStatus('role', paper, versionType), versionType)"
                                                            style="margin-right: 8px; vertical-align: middle;"></span>
                                                        <button type="button"
                                                            class="paper-reason-toggle"
                                                            *ngIf="hasPaperDetails(paper, versionType)"
                                                            (click)="togglePaperReason(i, paper, versionType)"
                                                            [attr.aria-label]="isPaperReasonExpanded(i, paper, versionType) ? 'Ocultar motivo do papel' : 'Exibir motivo do papel'"
                                                            [title]="isPaperReasonExpanded(i, paper, versionType) ? 'Ocultar motivo' : 'Exibir motivo'">
                                                            <svg-icon
                                                                src="assets/images/icon-right.svg"
                                                                class="paper-reason-toggle-icon"
                                                                [class.expanded]="isPaperReasonExpanded(i, paper, versionType)">
                                                            </svg-icon>
                                                        </button>
                                                        <span>{{
                                                            getPaperRoleLabel(paper)
                                                            }}</span>
                                                    </div>
                                                </td>
                                                <td
                                                    [style.text-decoration]="comparingVersions && versionType === 'comparing' && getPaperItemStatus(paper, versionType) === 'removed' ? 'line-through' : 'none'">
                                                    <span
                                                        *ngIf="comparingVersions && versionType === 'comparing' && getTableItemIcon(getPaperFieldStatus('status', paper, versionType), versionType)"
                                                        [innerHTML]="getTableItemIcon(getPaperFieldStatus('status', paper, versionType), versionType)"
                                                        style="margin-right: 8px; vertical-align: middle;"></span>
                                                    <span
                                                        [class]="getPaperStatusBadgeClass(paper)">
                                                        {{
                                                        getPaperStatusLabel(paper)
                                                        }}
                                                    </span>
                                                </td>
                                                <td
                                                    [style.text-decoration]="comparingVersions && versionType === 'comparing' && getPaperItemStatus(paper, versionType) === 'removed' ? 'line-through' : 'none'">
                                                    <span
                                                        *ngIf="comparingVersions && versionType === 'comparing' && getTableItemIcon(getPaperFieldStatus('homologated_at', paper, versionType), versionType)"
                                                        [innerHTML]="getTableItemIcon(getPaperFieldStatus('homologated_at', paper, versionType), versionType)"
                                                        style="margin-right: 8px; vertical-align: middle;"></span>
                                                    {{
                                                    getPaperHomologatedAt(paper)
                                                    }}</td>
                                                <td
                                                    [style.text-decoration]="comparingVersions && versionType === 'comparing' && getPaperItemStatus(paper, versionType) === 'removed' ? 'line-through' : 'none'">
                                                    <span
                                                        *ngIf="comparingVersions && versionType === 'comparing' && getTableItemIcon(getPaperFieldStatus('activated_at', paper, versionType), versionType)"
                                                        [innerHTML]="getTableItemIcon(getPaperFieldStatus('activated_at', paper, versionType), versionType)"
                                                        style="margin-right: 8px; vertical-align: middle;"></span>
                                                    {{
                                                    getPaperActivatedAt(paper, versionType)
                                                    }}</td>
                                                <td
                                                    [style.text-decoration]="comparingVersions && versionType === 'comparing' && getPaperItemStatus(paper, versionType) === 'removed' ? 'line-through' : 'none'">
                                                    <span
                                                        *ngIf="comparingVersions && versionType === 'comparing' && getTableItemIcon(getPaperFieldStatus('inactivated_at', paper, versionType), versionType)"
                                                        [innerHTML]="getTableItemIcon(getPaperFieldStatus('inactivated_at', paper, versionType), versionType)"
                                                        style="margin-right: 8px; vertical-align: middle;"></span>
                                                    {{
                                                    getPaperInactivatedAt(paper, versionType)
                                                    }}</td>
                                            </tr>

                                            <tr class="paper-reason-row"
                                                *ngIf="hasPaperDetails(paper, versionType) && isPaperReasonExpanded(i, paper, versionType)">
                                                <td colspan="5">
                                                    <div class="paper-reason-content">
                                                        <ng-container
                                                            *ngIf="hasPaperReason(paper, versionType)">
                                                            <span
                                                                class="paper-reason-label">{{getPaperReasonLabel(paper, versionType)}}</span>
                                                            <span>{{
                                                                getPaperReasonText(paper, versionType)
                                                                }}</span>
                                                        </ng-container>
                                                        <div>
                                                            <span
                                                                class="paper-reason-label">Usuário:</span>
                                                            <span>{{
                                                                getPaperActionUserName(paper, versionType)
                                                                }}</span>
                                                        </div>
                                                        <div>
                                                            <span
                                                                class="paper-reason-label">Documento:</span>
                                                            <span>{{
                                                                getPaperActionUserDocument(paper, versionType)
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </ng-container>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>

                    <ng-container
                        *ngIf="getCardLoadingForView(versionType)?.bank_information">
                        <ngx-skeleton-loader [theme]="{
                        height: '244px'
                    }">
                        </ngx-skeleton-loader>
                    </ng-container>

                    <div class="dash-details-card">
                        <ng-container
                            *ngIf="!getCardLoadingForView(versionType)?.bank_information">
                            <div class="dash-details-card-header">
                                <span>Contas bancárias</span>

                                <ng-container
                                    *ngIf="filteredFiles && getFilteredFilesForView(versionType)?.bank_account">
                                    <app-attachment-button
                                        [slugArr]="getFilteredFilesForView(versionType)?.bank_account"
                                        (onSelect)="handleSelect($event,'bank_account')">
                                    </app-attachment-button>
                                </ng-container>
                            </div>
                            <app-spacer [bottom]="25"></app-spacer>

                            <!-- Tabela de Dados Bancários -->
                            <div *ngIf="(versionType === 'comparing' ? getTableDataForComparison(mainBankData, comparingBankData, versionType) : getBankDataForView(versionType)).length"
                                class="table-container">
                                <table class="bank-data-table">
                                    <thead>
                                        <tr>
                                            <th>Banco</th>
                                            <th>Conta</th>
                                            <th>Tipo de conta</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of (versionType === 'comparing' ? getTableDataForComparison(mainBankData, comparingBankData, versionType) : getBankDataForView(versionType))"
                                            [ngClass]="comparingVersions && versionType === 'comparing' ? getTableItemRowClass(getBankItemStatus(item, versionType), versionType) : ''">
                                            <td
                                                [style.text-decoration]="comparingVersions && versionType === 'comparing' && getBankItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                <span
                                                    *ngIf="comparingVersions && versionType === 'comparing' && getTableItemIcon(getBankItemStatus(item, versionType), versionType)"
                                                    [innerHTML]="getTableItemIcon(getBankItemStatus(item, versionType), versionType)"
                                                    style="margin-right: 8px; vertical-align: middle;"></span>
                                                {{ item.bank.bank_code }} - {{
                                                item.bank.name }}
                                            </td>
                                            <td
                                                [style.text-decoration]="comparingVersions && versionType === 'comparing' && getBankItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                Ag: {{ item.agency }} Conta: {{
                                                item.account_number }}{{
                                                item.account_digit ? '-' +
                                                item.account_digit : '' }}
                                            </td>
                                            <td
                                                [style.text-decoration]="comparingVersions && versionType === 'comparing' && getBankItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                                <span>{{
                                                    item.account_type_display
                                                    ?? 'Conta corrente'
                                                    }}</span>
                                                <span *ngIf="item.main_account"
                                                    class="app-table-details-body-row-subtitle">{{
                                                    item.main_account ? 'Conta
                                                    principal' : '' }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <ng-container
                                *ngIf="(versionType === 'comparing' ? getTableDataForComparison(mainBankData, comparingBankData, versionType) : getBankDataForView(versionType)).length === 0">
                                <div class="dash-details-card-body">
                                    <div class="d-flex justify-content-center">
                                        <span>Nenhuma conta bancária
                                            cadastrada</span>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </div>

            <!-- Card Condição de Investidor (apenas para cotista PF e PJ) - Comparação de Versões -->
            <!-- <ng-container
                *ngIf="isShareholder() && ['complementary', 'bank', 'all'].includes(activeTab)">
                <div class="row">
                    <div class="col-12">
                        <ng-container
                            *ngIf="!registrationExpirationInfo || !registrationExpirationInfo.raw">
                            <ngx-skeleton-loader [theme]="{
                                height: '244px'
                            }">
                            </ngx-skeleton-loader>
                        </ng-container>

                        <ng-container
                            *ngIf="registrationExpirationInfo && registrationExpirationInfo.raw">
                            <ng-container
                                *ngIf="getInvestorProfileData() as investorData">
                                <div class="dash-details-card">
                                    <div class="dash-details-card-header">
                                        <span>Condição de Investidor</span>
                                    </div>
                                    <app-spacer [bottom]="25"></app-spacer>

                                    <div class="dash-details-card-body">
                                        <div class="row">
                                            <div class="col-12 col-md-6">
                                                <div class="d-flex flex-column">
                                                    <span
                                                        class="dash-details-card-item-subtitle">
                                                        Qualificação
                                                    </span>
                                                    <span
                                                        class="dash-details-card-item-title">
                                                        {{renderQualificationLabel(investorData?.qualification)}}
                                                    </span>
                                                    <app-spacer
                                                        [bottom]="16"></app-spacer>
                                                </div>
                                            </div>

                                            <div class="col-12 col-md-6">
                                                <div class="d-flex flex-column">
                                                    <span
                                                        class="dash-details-card-item-subtitle">
                                                        Condição de Investidor
                                                    </span>
                                                    <span
                                                        class="dash-details-card-item-title">
                                                        {{renderInvestorConditionLabel(investorData?.investor_condition)}}
                                                    </span>
                                                    <app-spacer
                                                        [bottom]="16"></app-spacer>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </div>
            </ng-container> -->

            <ng-container *ngIf="!isOnlyRepresentative">
                <ng-container
                    *ngIf="getCardLoadingForView(versionType)?.pep_relationship">
                    <ngx-skeleton-loader [theme]="{
                            height: '244px',
                            margin:'0 0 24px'
                        }">
                    </ngx-skeleton-loader>
                </ng-container>

                <ng-container
                    *ngIf="!getCardLoadingForView(versionType)?.pep_relationship">
                    <div class="col-12 p-0"
                        *ngIf="getApprovalDataForView(versionType)?.register?.type !== 'PJ'">
                        <div class="dash-details-card">
                            <div class="dash-details-card-header">
                                <span>Possui relacionamento com PEP</span>
                            </div>
                            <app-spacer [bottom]="25"></app-spacer>

                            <div class="dash-details-card-body">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-column"
                                            [style.padding-bottom]="versionType === 'comparing' && getPepFieldStatus('name', versionType) !== 'unchanged' ? '8px' : '0'">
                                            <span
                                                class="dash-details-card-item-subtitle"
                                                style="display: flex; align-items: center; gap: 6px;">
                                                <span
                                                    *ngIf="hasFieldComparisonIcon('pep.name', versionType)"
                                                    [innerHTML]="getFieldComparisonIcon('pep.name', versionType)"></span>
                                                <span>Nome</span>
                                            </span>
                                            <span
                                                class="dash-details-card-item-title"
                                                [ngClass]="getFieldStrikethroughClass('pep.name', versionType)">
                                                {{getPepFieldValueForDisplay('name',
                                                versionType)}}
                                            </span>
                                            <app-spacer
                                                [bottom]="16"></app-spacer>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-column"
                                            [style.padding-bottom]="versionType === 'comparing' && getPepFieldStatus('document', versionType) !== 'unchanged' ? '8px' : '0'">
                                            <span
                                                class="dash-details-card-item-subtitle"
                                                style="display: flex; align-items: center; gap: 6px;">
                                                <span
                                                    *ngIf="hasFieldComparisonIcon('pep.document', versionType)"
                                                    [innerHTML]="getFieldComparisonIcon('pep.document', versionType)"></span>
                                                <span>Documento</span>
                                            </span>
                                            <span
                                                class="dash-details-card-item-title"
                                                [ngClass]="getFieldStrikethroughClass('pep.document', versionType)">
                                                {{getPepFieldValueForDisplay('document',
                                                versionType)}}
                                            </span>
                                            <app-spacer
                                                [bottom]="16"></app-spacer>
                                        </div>
                                    </div>

                                    <div class="col-12 col-md-6">
                                        <div class="d-flex flex-column"
                                            [style.padding-bottom]="versionType === 'comparing' && getPepFieldStatus('bound', versionType) !== 'unchanged' ? '8px' : '0'">
                                            <span
                                                class="dash-details-card-item-subtitle"
                                                style="display: flex; align-items: center; gap: 6px;">
                                                <span
                                                    *ngIf="hasFieldComparisonIcon('pep.bound', versionType)"
                                                    [innerHTML]="getFieldComparisonIcon('pep.bound', versionType)"></span>
                                                <span>Vínculo</span>
                                            </span>
                                            <span
                                                class="dash-details-card-item-title"
                                                [ngClass]="getFieldStrikethroughClass('pep.bound', versionType)">
                                                {{getPepFieldValueForDisplay('bound',
                                                versionType)}}
                                            </span>
                                            <app-spacer
                                                [bottom]="16"></app-spacer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>

    <div class="row">
        <ng-container
            *ngIf="['complementary', 'economic-group', 'all'].includes(activeTab)">
            <ng-container
                *ngIf="getCardLoadingForView(versionType)?.economic_group">
                <ngx-skeleton-loader [theme]="{
                        height: '244px',
                        margin:'0 0 24px'
                    }">
                </ngx-skeleton-loader>
            </ng-container>

            <ng-container
                *ngIf="!getCardLoadingForView(versionType)?.economic_group">
                <div class="col-12"
                    *ngIf="getApprovalDataForView(versionType)?.register?.type === 'PJ' && !getIsFundForView(versionType)">
                    <div class="dash-details-card">
                        <div class="dash-details-card-header">
                            <span>Grupo econômico</span>

                            <ng-container
                                *ngIf="filteredFiles && getFilteredFilesForView(versionType)?.economic_group">
                                <app-attachment-button
                                    [slugArr]="getFilteredFilesForView(versionType)?.economic_group"
                                    (onSelect)="handleSelect($event,'economic_group')">
                                </app-attachment-button>
                            </ng-container>
                        </div>
                        <app-spacer [bottom]="25"></app-spacer>

                        <!-- Tabela de Grupo Econômico -->
                        <div *ngIf="(versionType === 'comparing' ? getTableDataForComparison(mainEconomicGroupData, comparingEconomicGroupData, versionType) : getEconomicGroupDataForView(versionType)).length > 0"
                            class="table-container">
                            <table class="economic-group-table">
                                <thead>
                                    <tr>
                                        <th>Razão Social</th>
                                        <th>CNPJ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of (versionType === 'comparing' ? getTableDataForComparison(mainEconomicGroupData, comparingEconomicGroupData, versionType) : getEconomicGroupDataForView(versionType))"
                                        [ngClass]="comparingVersions && versionType === 'comparing' ? getTableItemRowClass(getEconomicGroupItemStatus(item, versionType), versionType) : ''">
                                        <td
                                            [style.text-decoration]="comparingVersions && versionType === 'comparing' && getEconomicGroupItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                            <span
                                                *ngIf="comparingVersions && versionType === 'comparing' && getTableItemIcon(getEconomicGroupItemStatus(item, versionType), versionType)"
                                                [innerHTML]="getTableItemIcon(getEconomicGroupItemStatus(item, versionType), versionType)"
                                                style="margin-right: 8px; vertical-align: middle;"></span>
                                            {{ item.corporate_name.toUpperCase()
                                            }}
                                        </td>
                                        <td
                                            [style.text-decoration]="comparingVersions && versionType === 'comparing' && getEconomicGroupItemStatus(item, versionType) === 'removed' ? 'line-through' : 'none'">
                                            {{
                                            formatCnpj(item.company_document_number)
                                            }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Empty state quando não há grupo econômico -->
                        <ng-container
                            *ngIf="(versionType === 'comparing' ? getTableDataForComparison(mainEconomicGroupData, comparingEconomicGroupData, versionType) : getEconomicGroupDataForView(versionType)).length === 0">
                            <div class="dash-details-card-body"
                                style="padding: 60px 20px; min-height: 200px;">
                                <app-empty-content [isVisible]="true"
                                    title="Nenhum grupo econômico cadastrado"
                                    description="Não há informações de grupo econômico cadastradas para este registro."
                                    icon="/assets/images/forgot-password-icon2.png">
                                </app-empty-content>
                            </div>
                        </ng-container>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>

                <div class="col-12"
                    *ngIf="getApprovalDataForView(versionType)?.register?.type === 'PJ' && getIsFundForView(versionType) && getFieldValueForDisplay('register.company.exclusive_fund', getApprovalDataForView(versionType)?.register?.company.exclusive_fund, versionType) && (getApprovalDataForView(versionType)?.register?.company?.exclusive_fund_beneficiaries?.length > 0)">
                    <div class="dash-details-card">
                        <div class="dash-details-card-header">
                            <span>Beneficiários do fundo exclusivo</span>
                        </div>
                        <app-spacer [bottom]="25"></app-spacer>
                        <div class="table-container">
                            <table class="economic-group-table">
                                <thead>
                                    <tr>
                                        <th style="text-transform:capitalize">
                                            Nome</th>
                                        <th>Documento</th>
                                        <th>Estrangeiro</th>
                                        <th>PEP</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="let b of getApprovalDataForView(versionType)?.register?.company?.exclusive_fund_beneficiaries">
                                        <td>{{ b.name ?? '--' }}</td>
                                        <td>{{ b.document?.length === 11 ?
                                            formatCpf(b.document) :
                                            (b.document?.length === 14 ?
                                            formatCnpj(b.document) : (b.document
                                            ?? '--')) }}</td>
                                        <td>{{ b.document && b.document.length
                                            !== 11 && b.document.length !== 14 ?
                                            'Sim' : 'Não' }}</td>
                                        <td>{{ b.is_pep ? 'Sim' : 'Não' }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <app-spacer [bottom]="24"></app-spacer>
                    </div>
                    <app-spacer [bottom]="24"></app-spacer>
                </div>
            </ng-container>
        </ng-container>

    </div>
    <app-spacer [bottom]="24"></app-spacer>
</ng-template>

<app-modal #modalRoot class="modal-demo">
    <ng-container class="app-modal-header">
        <ng-container *ngIf="selectedFile">
            <svg-icon src="assets/images/icon_drag_indicator.svg"></svg-icon>
            <div class="text-center">
                {{modalFiles[0].type.name}}</div>
            <div></div>
        </ng-container>
    </ng-container>

    <ng-container class="app-modal-body">
        <ng-container *ngIf="selectedFile">
            <img [src]="selectedFile.url" *ngIf="selectedFile.isImg"
                style="width:100%">

            <iframe [src]="selectedFile.url" *ngIf="!selectedFile.isImg"
                frameborder="0" height="100%" width="100%">
            </iframe>
        </ng-container>
    </ng-container>

    <ng-container class="app-modal-footer">
        <div class="attachment-modal-navigation">
            <button class="attachment-modal-navigation-arrow"
                (click)="setPrevAttachment()" [disabled]="getDisabled('prev')">
                <svg-icon src="assets/images/icon-arrow-left.svg"></svg-icon>
            </button>

            <div class="pl-3 pr-3">{{selectedFile?.name ?
                urlDecoding(selectedFile.name) : ''}}</div>

            <button class="attachment-modal-navigation-arrow"
                (click)="setNextAttachment()" [disabled]="getDisabled('next')">
                <svg-icon src="assets/images/icon-arrow-right.svg"></svg-icon>
            </button>
        </div>
    </ng-container>
</app-modal>